import { createContext } from "react";
import socketio from "socket.io-client";

export const socket = socketio(process.env.REACT_APP_BE_API_URL);
export const SocketContext = createContext();
